import { GoLocation } from "react-icons/go";
import SectionWithTitle from "../SectionWithTitle";

import styled from "styled-components";
import MapWithDarkMode from "../../../../map/MapWithDarkMode";
import { useContext, useEffect, useState } from "react";
import MapWithMultipleMarkers from "../../../../map/MapWithMultipleMarkers";
import { serverLine } from "../../../../../controllers/network/serverLine";
import LoadingSection from "../../../../helperComponents/LoadingSection";
import Context from "../../../../../Context";
import ZoneDropDownInput from "../../sites/ZoneDropDownInput";
import { useTranslation } from "react-i18next";

const location = {
  address: "1600 Amphitheatre Parkway, Mountain View, california.",
  lat: 37.42216,
  lng: -122.08427,
};

const LocationPin = ({ text }) => (
  <div className="pin">
    <GoLocation />
    <p className="pin-text">{text}</p>
  </div>
);

const Container = styled.div`
  flex: 1;
  border: 1px solid var(--border);
  background: var(--gradientSurface);
  padding: 0;
  border-radius: 10px;
  position: relative;
  overflow: hidden;
  width: 50vw;
  animation: centerScaleReveal 0.6s ease-in-out forwards;

  @media (max-width: 900px) {
    width: 100%;
    height: 500px;
    flex: unset;
  }
`;
const Title = styled.div`
  margin: 0;
  position: absolute;
  top: 10px;
  z-index: 55;
  font-size: 12px;
  left: 10px;
  padding: 10px 15px;
  color: var(--element);
  font-weight: 700;
  /* opacity: 0.6; */
  border-radius: 15px;
  border: 1px solid var(--borderDim);
  background: var(--elementAlt);
  z-index: 20;
  backdrop-filter: blur(200px);
`;

const TopSection = styled.div`
  margin: 0;
  position: absolute;
  top: 10px;
  z-index: 55;
  font-size: 12px;
  left: 0;
  top: 0;
  padding: 10px 15px;
  display: flex;
  flex-direction: row;
  /* width: 100%; */ //don't do 100% maximize button gets block
  z-index: 20;
  justify-content: space-between;
`;

const DropDownContianer = styled.div`
  background: var(--surfaceSolid);
  border-radius: 10px;
  overflow: hidden;
`;

export default function MapSectionForManagement() {
  const { t } = useTranslation();
  const [zoneID, setZoneID] = useState(null);
  const { preloadedSites } = useContext(Context);

  if (!preloadedSites)
    return (
      <Container>
        <LoadingSection />
      </Container>
    );

  let locations = [];

  for (let key in preloadedSites) {
    let item = preloadedSites[key];
    if (zoneID) {
      if (item.zoneID !== zoneID) {
        continue;
      }
    }
    locations.push({
      lat: item.latitude,
      lng: item.longitude,
      text: item.placeName,
    });
  }

  return (
    <Container>
      <TopSection>
        {/* <Title>Locations</Title> */}
        {/* ascasc */}
        <DropDownContianer>
          <ZoneDropDownInput
            label={t("Zone")}
            value={zoneID}
            onChange={setZoneID}
            autoSetInitialValue={false}
          />
        </DropDownContianer>
      </TopSection>

      <MapWithMultipleMarkers
        markers={locations}
        versionForUpdating={`${zoneID}-${Object.keys(preloadedSites).length}`}
      />
    </Container>
  );
}
